export default "__VITE_ASSET__e1b34363__"